import { Component, OnChanges, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DataService } from '../../shared/dataservice.service';
import { GenService } from '../../shared/gen-ser.service';
import { NotificationsService } from 'angular2-notifications';
import { GenResponse } from '../../shared/misc-classes';
import { ErrorPopupComponent } from '../../common/error-popup/error-popup.component';

@Component({
  selector: 'app-safety-app',
  templateUrl: './safety-app.component.html',
  styleUrls: ['./safety-app.component.css']
})
export class SafetyAppComponent implements OnChanges {
  dateSel :number = 0;  
  mId:string = "";
  fieldSelection:number;
  comments:any;

  @Input() selMonth: string;
  @Input() selProductType: string;
  @Input() data: any;
  @Output() updateData = new EventEmitter<any>();
  
  @ViewChild('childModal') public childModal:ModalDirective;
  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;

  constructor(public _dataService:DataService,private _notify:NotificationsService) { }

  ngOnChanges() {
  } 
   hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  openModal(num){
    this.fieldSelection = null;
    this.comments = null;
    this.dateSel = num;
    if(this.data && this.data.data){
      for(var i=0;i<this.data.data.length;i++){
        if(this.data.data[i].day == num){
          this.fieldSelection = this.data.data[i].field_selection;
          this.comments = this.data.data[i].comments
        }
      }
    }
     this.childModal.show();
    
  }
  public hideChildModal():void {
    this.childModal.hide();
  }
  getProductType(type:string){
    if(type){
      return this._dataService.getProductType(type);
    }
  }
  formatMonth(_dateObj:string):string{
    let dateObj = new Date(_dateObj);
    if(dateObj){
      return GenService.getDateFormatStr(dateObj , "MMM-YYYY");
    }
    return '-';
  }
  addColor(num){
    var isFound = false;
    if(this.data && this.data.data){
      for(var i=0;i<this.data.data.length;i++){
        if(this.data.data[i].day == num){
          isFound = true;
          if(this.data.data[i].field_selection == 0){
              return 'green'
          }
          else if(this.data.data[i].field_selection == 1){
            return 'blue'
          }
          else if(this.data.data[i].field_selection == 2){
            return 'red'
          }
          else{
            return 'white'
          }       
        }
      }
    }
    if(!isFound){
      if(!this.selProductType)
        return 'white'
      else{
        var _tmpDate = new Date(this.selMonth);
        if(num < _tmpDate.getDate() && _tmpDate.getMonth() == new Date().getMonth() && _tmpDate.getFullYear() == new Date().getFullYear()){
          var day = new Date(_tmpDate.setDate(num)).getDay();
          if(day == 0 || day == 6)
              return 'white'
          else
              return 'green'
        }
        else if(_tmpDate.getMonth() < new Date().getMonth() && _tmpDate.getFullYear() <= new Date().getFullYear()){ 
          var day = new Date(_tmpDate.setDate(num)).getDay();
          if(day == 0 || day == 6)
            return 'white'
        else
          return 'green'
        }
        else if(_tmpDate.getMonth() > new Date().getMonth() && _tmpDate.getFullYear() < new Date().getFullYear()){ 
          var day = new Date(_tmpDate.setDate(num)).getDay();
          if(day == 0 || day == 6)
            return 'white'
        else
          return 'green'
        }
        else
          return 'white'
      }
    }
  }
  saveData(fs,cm){
    let temp=<any>{};   
    temp.month = new Date(this.selMonth).getMonth()+1;
    temp.year = new Date(this.selMonth).getFullYear();
    temp.productType = this.selProductType;
    if(this.data){
      temp.id = this.data.id
      temp.ts = this.data.ts;
    }    
    temp.type="Safety";
    temp.day = this.dateSel;
    temp.fieldSelection = fs;
    temp.comments = cm;
    this._dataService.saveGembaCardsData(temp).subscribe((resp:GenResponse) => {
      if(resp.status == "OK"){
        this._notify.success('Success','Data Saved.',this._dataService.successOptions);
        this.updateData.emit();  
        this.childModal.hide();
      }
      else{
        if (resp.errorCode == DataService.staleDataCode) {
          this.errorPopup.showErrorPopup("Stale Data", resp.details)
        } else {
          this._notify.error('Failure', resp.details, this._dataService.failureOptions);
        }
      }
    });
  }
  
  reloadData(){
    this.updateData.emit();  
    this.childModal.hide();
  }

}
